import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-58433d7f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "ojQuestionAddPage" }
const _hoisted_2 = { style: {"text-align":"center"} }
const _hoisted_3 = { class: "btn" }

import WangEditor from "@/components/WangEditor.vue";
import { ref, watchEffect } from "vue";
import {
  addOjQuestionDetailUsingPost,
  deleteOjQuestionDetailUsingPost,
  getOjQuestionDetailUsingGet,
  updateOjQuestionDetailUsingPost,
} from "@/api/ojQuestionController";
import API from "@/api";
import { Message } from "@arco-design/web-vue";
import OjJudgeCaseModal from "@/views/oj/components/OjJudgeCaseModal.vue";

import OjQuestionDetailAddRequest = API.OjQuestionDetailAddRequest;
interface Props {
  id: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OjQuestionAddPage',
  props: {
    id: { default: () => {
    return "";
  } }
  },
  setup(__props: any) {

const props = __props;

const ojQuestionDetail = ref<OjQuestionDetailAddRequest>({});
const tips = ref<string[]>([]);
const wangEditorRef = ref();

const updateValueHtml = (value: string) => {
  ojQuestionDetail.value.content = value;
};

/**
 * 加载数据
 */
const loadData = async () => {
  if (!props.id) {
    return;
  }
  const res = await getOjQuestionDetailUsingGet({
    id: props.id as any,
  });
  if (res.data.code === 200) {
    ojQuestionDetail.value = res.data.data as any;
    tips.value = ojQuestionDetail.value.tips as any;
    wangEditorRef.value.setValueHtml(ojQuestionDetail.value.content);
  } else {
    Message.error("获取数据失败，" + res.data.message);
  }
};

const deleteOjQuestion = async () => {
  const res = await deleteOjQuestionDetailUsingPost({
    id: props.id as any,
  });
  if (res.data.code === 200) {
    Message.success("删除成功");
  } else {
    Message.error("删除失败，" + res.data.message);
  }
};

const addOjQuestion = async () => {
  if (!props.id) {
    // 添加题目
    const res = await addOjQuestionDetailUsingPost({
      ...ojQuestionDetail.value,
      ...tips.value,
    });
    if (res.data.code === 200) {
      Message.success("添加成功");
    } else {
      Message.error("添加失败，" + res.data.message);
    }
  } else {
    // 修改题目
    const res = await updateOjQuestionDetailUsingPost({
      ...ojQuestionDetail.value,
      ...tips.value,
      id: props.id as any,
    });
    if (res.data.code === 200) {
      Message.success("修改成功");
    } else {
      Message.error("修改失败，" + res.data.message);
    }
  }
};

const ojJudgeCaseModalRef = ref();
const showOjJudgeCase = () => {
  ojJudgeCaseModalRef.value.openModal();
};

watchEffect(() => {
  loadData();
});

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_tag = _resolveComponent("a-input-tag")!
  const _component_a_collapse_item = _resolveComponent("a-collapse-item")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.id === "" ? "添加题目" : "编辑题目"), 1),
    _createVNode(_component_a_form, { model: ojQuestionDetail.value }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          label: "题目标题",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: ojQuestionDetail.value.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ojQuestionDetail.value.title) = $event)),
              modelModifiers: { number: true },
              placeholder: "请输入标题"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "题目难度",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              modelValue: ojQuestionDetail.value.difficulty,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ojQuestionDetail.value.difficulty) = $event)),
              placeholder: "请输入难度"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_option, {
                  label: "简单",
                  value: 0
                }),
                _createVNode(_component_a_option, {
                  label: "中等",
                  value: 1
                }),
                _createVNode(_component_a_option, {
                  label: "困难",
                  value: 2
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "题目标签",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_tag, {
              modelValue: ojQuestionDetail.value.tags,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ojQuestionDetail.value.tags) = $event)),
              placeholder: "请输入标签"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "时间限制",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: ojQuestionDetail.value.timeLimit,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ojQuestionDetail.value.timeLimit) = $event)),
              style: { width: '250px' },
              placeholder: "请输入时间限制"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "内存限制",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: ojQuestionDetail.value.memoryLimit,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ojQuestionDetail.value.memoryLimit) = $event)),
              style: { width: '250px' },
              placeholder: "请输入内存限制"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "题目内容",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(WangEditor, {
              ref_key: "wangEditorRef",
              ref: wangEditorRef,
              onUpdateValueHtml: updateValueHtml,
              "init-value-html": ojQuestionDetail.value.content
            }, null, 8, ["init-value-html"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "题目提示" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_collapse, {
              style: {"width":"100%"},
              "default-active-key": [1]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_collapse_item, {
                  header: "Tip1",
                  key: "1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      modelValue: tips.value[0],
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((tips.value[0]) = $event)),
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_collapse_item, {
                  header: "Tip2",
                  key: "2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      modelValue: tips.value[1],
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((tips.value[1]) = $event)),
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_collapse_item, {
                  header: "Tip3",
                  key: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      modelValue: tips.value[2],
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((tips.value[2]) = $event)),
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.id !== '')
          ? (_openBlock(), _createBlock(_component_a_form_item, {
              key: 0,
              label: "题目用例"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: showOjJudgeCase
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("点击")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_space, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            onClick: deleteOjQuestion,
            status: "danger",
            style: {"width":"200px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("删除题目")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            onClick: addOjQuestion,
            type: "primary",
            style: {"width":"200px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.id === "" ? "添加题目" : "修改题目"), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(OjJudgeCaseModal, {
      ref_key: "ojJudgeCaseModalRef",
      ref: ojJudgeCaseModalRef,
      id: _ctx.id
    }, null, 8, ["id"])
  ]))
}
}

})